import React from "react";
import { Truck, MapPin, Clock, Package, Globe, CreditCard } from "lucide-react";

export default function Shipping() {

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-950 text-white relative overflow-hidden">
      {/* Animated Gradient Orbs */}
      <div className="absolute -top-20 -left-20 w-72 h-72 bg-orange-600/30 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-10 right-10 w-96 h-96 bg-yellow-600/30 rounded-full blur-3xl animate-ping"></div>

      <div className="relative max-w-4xl mx-auto p-8 space-y-8 z-10">

        {/* Header */}
        <div className="text-center">
          <h1 className="text-4xl font-extrabold flex items-center justify-center gap-3 mb-4">
            <Truck className="w-10 h-10 text-orange-500 animate-bounce" />
            Shipping Information
          </h1>
          <p className="text-gray-400 text-lg">Delivery options and policies for physical merchandise</p>
        </div>

        {/* Content Sections */}
        <div className="space-y-6">

          {/* Digital vs Physical */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-4 hover:shadow-orange-500/30 transition-all">
            <h2 className="text-2xl font-semibold flex items-center gap-2">
              <Globe className="w-6 h-6 text-orange-400" /> Digital vs Physical Products
            </h2>
            <div className="space-y-3 text-gray-300">
              <p><strong>Digital Products:</strong> Music downloads, premium subscriptions, and digital content are delivered instantly via email or account access.</p>
              <p><strong>Physical Products:</strong> Merchandise, CDs, vinyl records, and promotional items are shipped to your address.</p>
            </div>
          </div>

          {/* Shipping Options */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-4 hover:shadow-yellow-500/30 transition-all">
            <h2 className="text-2xl font-semibold flex items-center gap-2">
              <Package className="w-6 h-6 text-orange-400" /> Shipping Options
            </h2>
            <div className="space-y-4 text-gray-300">
              <div className="space-y-2">
                <h3 className="text-lg font-medium text-orange-400">Standard Shipping</h3>
                <p>• Delivery within 5-7 business days</p>
                <p>• Free shipping on orders over ₹50</p>
                <p>• ₹5.99 for orders under ₹50</p>
              </div>
              <div className="space-y-2">
                <h3 className="text-lg font-medium text-orange-400">Express Shipping</h3>
                <p>• Delivery within 2-3 business days</p>
                <p>• ₹12.99 flat rate</p>
                <p>• Available for most locations</p>
              </div>
              <div className="space-y-2">
                <h3 className="text-lg font-medium text-orange-400">Overnight Shipping</h3>
                <p>• Next business day delivery</p>
                <p>• ₹24.99 flat rate</p>
                <p>• Available for select locations only</p>
              </div>
            </div>
          </div>

          {/* International Shipping */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-4 hover:shadow-orange-500/30 transition-all">
            <h2 className="text-2xl font-semibold flex items-center gap-2">
              <MapPin className="w-6 h-6 text-orange-400" /> International Shipping
            </h2>
            <div className="space-y-3 text-gray-300">
              <p><strong>Available Countries:</strong> We ship to over 100 countries worldwide.</p>
              <p><strong>Delivery Times:</strong> 7-14 business days for most international destinations.</p>
              <p><strong>Customs & Duties:</strong> Customer is responsible for all customs fees and import duties.</p>
              <p><strong>Tracking:</strong> International packages include tracking numbers for monitoring.</p>
            </div>
          </div>

          {/* Order Processing */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-4 hover:shadow-yellow-500/30 transition-all">
            <h2 className="text-2xl font-semibold flex items-center gap-2">
              <Clock className="w-6 h-6 text-orange-400" /> Order Processing
            </h2>
            <div className="space-y-3 text-gray-300">
              <p><strong>Processing Time:</strong> Orders are processed within 1-2 business days.</p>
              <p><strong>Business Days:</strong> Monday through Friday, excluding holidays.</p>
              <p><strong>Order Confirmation:</strong> You'll receive an email confirmation once your order ships.</p>
              <p><strong>Tracking Information:</strong> Provided via email with carrier tracking number.</p>
            </div>
          </div>

          {/* Shipping Restrictions */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-4 hover:shadow-orange-500/30 transition-all">
            <h2 className="text-2xl font-semibold flex items-center gap-2">
              <Package className="w-6 h-6 text-orange-400" /> Shipping Restrictions
            </h2>
            <div className="space-y-3 text-gray-300">
              <p>We cannot ship to P.O. boxes or military addresses (APO/FPO).</p>
              <p>Some products may have size or weight restrictions for certain shipping methods.</p>
              <p>Certain countries may have import restrictions on specific merchandise.</p>
            </div>
          </div>

          {/* Contact Information */}
          <div className="bg-white/5 backdrop-blur-lg rounded-2xl shadow-lg border border-white/10 p-6 space-y-4 hover:shadow-yellow-500/30 transition-all">
            <h2 className="text-2xl font-semibold flex items-center gap-2">
              <CreditCard className="w-6 h-6 text-orange-400" /> Questions?
            </h2>
            <div className="space-y-3 text-gray-300">
              <p>For shipping inquiries or issues, contact our customer service:</p>
          <p><strong>Email:</strong> samasong.music@gmail.com</p>
              <p><strong>Address:</strong> old market, Tawang, Arunachal Pradesh, 790104</p>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}